import { Box, TextField } from '@mui/material';
import {
  GridRenderCellParams,
  GridTreeNodeWithRender,
} from '@mui/x-data-grid-pro';
const EditableTextCell = (
  params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>
) => {
  const { id, value, field, api } = params;
  return (
    <Box>
      <TextField
        value={value}
        variant="standard"
        onChange={(ev) => {
          api.setEditCellValue({ id, field, value: ev.target.value });
        }}
        // slotProps={{
        //   input: { disableUnderline: true },
        // }}
        InputProps={{ disableUnderline: true }}
        sx={{
          '& .MuiInput-root': {
            fontSize: '12px',
            pl: 1,
          },
        }}
      />
    </Box>
  );
};
export default EditableTextCell;
